import room1 from '../assets/media/Image.png';
import room2 from '../assets/media/Image2.png';
import room3 from '../assets/media/Image3.png';
export default {
 
  LOGO: {
    PART_1: "Just",
    PART_2: "Stay",
  },

  
  NAV: {
    HOME: "Home",
    ABOUT: "About",
    ROOMS: "Rooms",
    SERVICES: "Services",
    CONTACT: "Contact",
  },


  BANNER: {
    WELCOME_TO: "Welcome To",
    LOCATION: "Ahmedabad India",
    DESCRIPTION:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quibusdam maxime praesentium Why did the scarecrow win an award? Because he was outstanding in his field. Lorem ipsum",
  },

  
  BUTTONS: {
    LOGOUT: "Logout",
    BOOK_NOW: "Book now",
    EXPLORE_MORE: "Explore More",
    READ_MORE: "Read More",
  },

  ABOUT: {
    TITLE: "About Us",
    HISTORY_TITLE: "History of",
    HISTORY_DESCRIPTION_MAIN:
      "JustStay began with a simple vision: to create exceptional hospitality experiences. Founded in 2010, we've grown from a small boutique hotel to a renowned chain, always maintaining our commitment to quality and personalized service.",
    HISTORY_DESCRIPTION_BOTTOM:
      "Our journey hasn't always been easy, but every challenge has helped us refine our approach. Today, we're proud to serve guests from around the world, offering comfort and memorable stays that keep them coming back.",
    WHY_CHOOSE_US_TITLE: "Why Choose Us?",
    WHY_CHOOSE_US_MAIN:
      "At JustStay, we combine modern amenities with traditional hospitality. Our dedicated staff, premium facilities, and attention to detail ensure every guest enjoys a perfect stay tailored to their needs.",
    WHY_CHOOSE_US_BOTTOM:
      "We're not just another hotel chain - we're a home away from home. Our locations are carefully selected, our services thoughtfully designed, and our commitment to excellence never wavers.",
  },

  FOOTER: {
    COMPANY_NAME: "JustStay",
    COMPANY_DESCRIPTION: "Recusandae quos nesciunt veniam eum quia",
    COMPANY_EMAIL: "shaikhsaad256@gmail.com",
    NAVIGATION: {
      TITLE: "Quick Links",
      LINKS: [
        { label: "Home", path: "/" },
        { label: "About Us", path: "/about" },
        { label: "Rooms", path: "/rooms" },
        { label: "Services", path: "/services" },
        { label: "Contact", path: "/contact" },
      ],
    },
  },
  ROOMS: {
    TITLE: "Our Rooms",
    SUBTITLE: "Explore Our Rooms",
    ROOMS_LIST: [
      {
        image: room1,
        title: "Junior Suite",
        price: "$150.00 / per night",
        description: "Comfortable and cozy room perfect for short stays",
      },
      {
        image: room2,
        title: "Deluxe Room",
        price: "$200.00 / per night",
        description: "Spacious room with premium amenities",
      },
      {
        image: room3,
        title: "Executive Suite",
        price: "$250.00 / per night",
        description: "Luxurious suite with extra space and services",
      },
    ],
  },

  
  SERVICES: {
    TITLE: "Our Services",
    SUBTITLE: "Explore Our Services",
    SERVICES_LIST: [
      {
        title: "Rooms & Appartment",
        description: "Premium accommodations with all modern comforts",
      },
      {
        title: "Sports & Gaming",
        description: "Recreational facilities for your entertainment",
      },
      {
        title: "Food & Restaurant",
        description: "Gourmet dining experiences with local flavors",
      },
      {
        title: "Spa & Fitness",
        description: "Relaxation and wellness services",
      },
      {
        title: "Event & Party",
        description: "Perfect venues for your special occasions",
      },
      {
        title: "GYM & Yoga",
        description: "Fitness facilities and wellness programs",
      },
    ],
  },

  
  TESTIMONIALS: {
    TITLE: "What People Say?",
    SUBTITLE: "Testimonial",
    REVIEWS: [
      {
        name: "Rita",
        surname: "O'Conner",
        email: "Sandrine.Luettgen@gmail.com",
        description:
          "The stay was absolutely wonderful! The staff went above and beyond to make our visit special.",
      },
      {
        name: "Woodrow",
        surname: "McCullough",
        email: "Idell.Hoppe86@yahoo.com",
        description:
          "Best hotel experience I've had in years. The attention to detail was remarkable.",
      },
      {
        name: "Veronica",
        surname: "Hessel",
        email: "Valentin.Homenick@gmail.com",
        description:
          "Perfect location, amazing service, and the rooms were spotless. Highly recommend!",
      },
      {
        name: "George",
        surname: "Heaney",
        email: "Liliana.Howell85@hotmail.com",
        description:
          "The comfort and luxury exceeded all our expectations. We'll definitely be back.",
      },
    ],
  },

  
  STATS: {
    ITEMS: [
      {
        value: "8",
        label: "Years of Service",
      },
      {
        value: "459",
        label: "Sq. Meter Area",
      },
      {
        value: "50",
        label: "Nice Rooms",
      },
      {
        value: "3786",
        label: "Happy Visitors",
      },
    ],
  },
};
